<template>
    <v-alert
        variant="outlined"
        color="secondary"
        density="compact"
        class="my-8"
    >
        <p>
            {{ brandTitle }} apparel is made to order. Most orders ship within 4 business days. StringKing apparel can be returned for a full refund within 14 days of receipt. Return shipping is free.
        </p>
    </v-alert>
</template>

<script lang="ts" setup>
    const $config = useRuntimeConfig();
    const brandTitle = $config.public.brand.title;
</script>

<style lang="scss" scoped></style>
